import { Comments } from 'components/comments'
import { apiPaths } from 'configs/apiConfigs'
import { addClaimComment, getClaimComments } from 'features/claims/claimsApi'
import { IComments } from 'features/claims/types'
import { useEffect, useState } from 'react'
import { handleApiRequestWithStates } from 'utils'
import { notificator } from 'utils/notificator/notificator'
import { COMMENTS_LIMIT } from './Constants'

interface IProps {
  claimId: string
  archived: boolean
}

export interface CommentsControls {
  count: number
  limit: number
  offset: number
}

const initialControls: CommentsControls = {
  count: 0,
  limit: 0,
  offset: 0,
}
export const ClaimDetailsComments = ({ claimId, archived }: IProps) => {
  const [items, setItems] = useState<IComments[]>([])
  const [hasMore, setHasMore] = useState(true)
  const [commentOffset, setCommentOffset] = useState<number>(COMMENTS_LIMIT)

  const [isLoading, setLoading] = useState(false)
  const [commentsControl, setCommentsControl] = useState<CommentsControls>({ ...initialControls })

  const [isSaveCompleted, setSaveComplete] = useState(false)
  useEffect(() => {
    const query = `offset=${0}&limit=${COMMENTS_LIMIT}`
    const url = apiPaths.claimComments(claimId, query)
    const getComments = async () => {
      const res = await handleApiRequestWithStates(() => getClaimComments(url), setLoading)
      const data = res.data

      if (data && data?.data.length < 1) {
        setHasMore(false)
      }
      if (data) {
        setCommentsControl(data)
        setItems(data.data)
      }
    }

    getComments()
  }, [])

  const fetchComments = async (url: string) => {
    const res = await handleApiRequestWithStates(() => getClaimComments(url), setLoading)
    const data = res.data
    return data
  }

  const fetchData = async () => {
    const query = `offset=${commentOffset}&limit=${COMMENTS_LIMIT}`
    const url = apiPaths.claimComments(claimId, query)
    const comments = await fetchComments(url)

    if (comments) {
      setCommentsControl(comments)
      setItems([...items, ...comments.data])
      if (comments.data.length === 0 || comments.data.length < COMMENTS_LIMIT) {
        setHasMore(false)
      }
      setCommentOffset(comments?.offset + COMMENTS_LIMIT)
    }
  }

  const saveComment = async (text: string) => {
    setSaveComplete(false)
    const comment = {
      note: text,
    }

    const { data, error } = await handleApiRequestWithStates(
      () => addClaimComment(claimId, comment as IComments),
      setLoading,
    )
    if (error) {
      notificator.notify({
        heading: 'Unable to add comment. Please try again later',
        type: 'error',
      })
      //notificator.error('Unable to add comment. Please try again later')
    }
    if (data && commentsControl.count <= 0) {
      setSaveComplete(true)
      setCommentsControl({ count: 1, limit: 10, offset: 0 })
    }
    if (data) {
      setSaveComplete(true)
      setItems([...[data], ...items])
      notificator.notify({
        heading: 'Your comment was successfully added',
        type: 'success',
      })
      //notificator.success('Your comment was successfully added')
    }
  }

  return (
    <Comments
      comments={items}
      totalCount={commentsControl.count}
      charLimit={500}
      onScroll={() => fetchData()}
      hasMore={hasMore}
      onSubmit={(text: string) => saveComment(text)}
      loading={isLoading}
      isSaveCompleted={isSaveCompleted}
      disabled={archived}
    />
  )
}
